<script>
  import Layout from '@layout/main'
  import ArticleSide from '@components/Article/ArticleSide'
  import { FAKE_SESSION_ITEM } from "@src/config/fake-evnet";
  import { 
    eventIsEnd, 
    eventIsStart, 
    eventPublishDate, 
    eventOnlineStatusItem, 
    eventTimeRange, 
    eventIsComming,
    eventIsComminMinute,
    eventBeforeIsNearStart
  } from "@utils/zerone-event";
  import formatDate from '@utils/format-date'
  import BaseButton from "@components/Base/BaseButton";

  export default {
    page() {
      return {
        title: `${this.orderItem.title} | 線上直播`,
      }
    },
    components: {
      BaseButton,
      Layout,
      ArticleSide,
      File: () => import('@components/List/File'),
      ListPersonnels: () => import('@components/List/Personnels')
    },
    props: {
      orderItem: {
        type: Object,
        default: () => {
          return {};
        },
      },
      sessionItem: {
        type: Object,
        default: () => {
          return FAKE_SESSION_ITEM;
        },
      }
    },
    data() {
      return {
        type: 'live',
        // courseList: COURSE_LIST,
        hostname: window.location.hostname,
        // reciprocal: 10,
        // reciprocalTimer: null,
        setTime: null,
        sessionDefaultItem: { ...this.sessionItem },
        sessionsOnlineStatus: {
          mode: '',
          title: '',
          sessionTitle:  '',
          to: '',
          class: '',
          class2: '',
        },
        eventItem: {
          inProgress: eventIsStart(`${ this.sessionItem.date } ${ this.sessionItem.startTime }`) && !eventIsEnd(`${ this.sessionItem.date } ${ this.sessionItem.endTime }`),
          alias: this.orderItem?.alias,
          brands: this.orderItem?.brands,
          dateType: this.orderItem?.dateType,
          regStatus: this.orderItem?.regStatus,
          registrationType: this.orderItem?.registrationType,
          seriesNum: this.orderItem?.seriesNum,
          type: this.orderItem?.type,
          dateTimeRange: this.dateTimeRange,
          contact: this.orderItem?.contact,
          requiredEvent: this.orderItem?.requiredEvent || [],
          ...this.sessionItem, ...this.sessionItem?.info,
        },
        timeStep: 3000,
      }
    },
    computed: {
      isStart() {
        return eventIsStart(`${ this.sessionItem.date } ${ this.sessionItem.startTime }`);
      },
      isEnd() {
        return eventIsEnd(`${ this.sessionItem.date } ${ this.sessionItem.endTime }`);
      },
      youtubeId() {
        const vidoeUrl = this.sessionItem?.info?.link;

        if(vidoeUrl) {
          const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
          const match = vidoeUrl.match(regExp);
          return (match && match[7].length === 11)
            ? match[7]
            : false;
        }

        return '';
      },
      publishDate() {
        return eventPublishDate({
          linkOpeningTime: this.sessionItem?.info?.linkOpeningTime,
          dateTime: ''
        })
      },
      // sessionsOnlineStatus() {
      //   return eventOnlineStatusItem({
      //     alias: this.orderItem?.alias,
      //     seriesNum: this.orderItem?.seriesNum,
      //     uuid: this.sessionDefaultItem?.info.uuid,
      //     date: this.sessionDefaultItem?.date,
      //     startTime: this.sessionDefaultItem?.startTime,
      //     endTime: this.sessionDefaultItem?.endTime,
      //   })
      // },
      // eventItem() {
      //   return {
      //     inProgress: eventIsStart(`${ this.sessionItem.date } ${ this.sessionItem.startTime }`) && !eventIsEnd(`${ this.sessionItem.date } ${ this.sessionItem.endTime }`),
      //     alias: this.orderItem?.alias,
      //     brands: this.orderItem?.brands,
      //     dateType: this.orderItem?.dateType,
      //     regStatus: this.orderItem?.regStatus,
      //     registrationType: this.orderItem?.registrationType,
      //     seriesNum: this.orderItem?.seriesNum,
      //     type: this.orderItem?.type,
      //     dateTimeRange: this.dateTimeRange,
      //     contact: this.orderItem?.contact,
      //     requiredEvent: this.orderItem?.requiredEvent || [],
      //     ...this.sessionItem, ...this.sessionItem?.info
      //   }
      // },
      dateTimeRange() {
        const timeRange = eventTimeRange({ ...this.sessionItem });
        const date = formatDate(this.sessionItem.date, 'yyyy/MM/dd(EEE)');

        return `${ date } (${ timeRange })`
      },
    },
    watch: {
      'timeStep'(oldValue,newValue) {
        if(oldValue !== newValue) {
          this.setSessionsOnlineStatus()
          this. setEventItem()
        }
      }
    },
    mounted() {
      const inProgress = () => {
         // 是否已開始時間
        const isStart = eventIsStart(`${ this.sessionItem.date } ${ this.sessionItem.startTime }`);

        // 是否已結束時間
        const isEnd = eventIsEnd(`${ this.sessionItem.date } ${ this.sessionItem.endTime }`);
        
        // 開始時間前的五小時前
        const isBeforeHour = eventBeforeIsNearStart(`${ this.sessionItem.date } ${ this.sessionItem.startTime }`)

        // 開始時間前的五小時內
        const isNearStartHour = eventIsComming(`${ this.sessionItem.date } ${ this.sessionItem.startTime }`)

        // 開始時間前的五分鐘內
        const isNearStartMinute = eventIsComminMinute(`${ this.sessionItem.date } ${ this.sessionItem.startTime }`)

        // 結束時間前的五分鐘內
        const isNearEndMinute = eventIsComminMinute(`${ this.sessionItem.date } ${ this.sessionItem.endTime }`)

        // 是否是待報到以及已確認訂單
        const isCHECKIN = this.sessionDefaultItem.checkinStatus === 'CHECKIN' && this.sessionDefaultItem.regStatus === 'CONFIRMED'
 
        if(isStart && !isEnd && isCHECKIN) {
          this.tryToCheckin()
        }
        // 在前五小時以上
        if(isBeforeHour) {
          // 10分鐘
          this.timeStep = 600000 // 600000
          checkCurrentDateTime()
        //  前五小時內，五分鐘前
        } else if(isNearStartHour && !isNearStartMinute && !isStart || isStart && !isNearEndMinute && !isEnd){
          this.timeStep = 30000 // 30000
          checkCurrentDateTime()
        //  五分鐘內
        }else if (isNearStartMinute && !isStart || isNearEndMinute && !isEnd){
          this.timeStep = 10000 // 100000 
          checkCurrentDateTime()
        }else {
          if(this.setTime) {
            clearTimeout(this.setTime);
            this.timeStep = 30000
          }
        }
      }
      
      const checkCurrentDateTime = () => {
        this.setTime = setTimeout(() => {
          inProgress()
        }, this.timeStep) // 300000
      };

      setTimeout(()=>{
        this.setSessionsOnlineStatus()
        this.setEventItem()
      }, 600)

      inProgress()
    },
    destroyed() {
      const cleartoCheckCurrentDateTime = () => {
        clearTimeout(this.setTime);
      };
      cleartoCheckCurrentDateTime();
    },
    methods: {
      formatDate,
      goBack() {
        this.$router.back(-1)
      },
      async tryToCheckin() {
        await this.$store.dispatch('order/fetchOrderSessionsCheckin', {
          uuid: this.sessionDefaultItem?.info?.uuid
        }).then((responsive) => {
          // this.isCheckIned = true
          // this.tryToFecthSession()
          this.sessionDefaultItem.checkinStatus = 'CHECKEDIN'
        })
      },
      // async tryToFecthSession() {
      //   await this.$store.dispatch('order/fetchOrderSessions', {
      //     uuid: this.sessionDefaultItem?.info?.uuid
      //   }).then((responsive) => {
      //     // this.isCheckIned = true
      //     this.sessionDefaultItem = {
      //       ...this.sessionItem,
      //       ...responsive
      //     }
      //   })
      // },
      setSessionsOnlineStatus() {
        const status = eventOnlineStatusItem({
          alias: this.orderItem?.alias,
          seriesNum: this.orderItem?.seriesNum,
          uuid: this.sessionDefaultItem?.info.uuid,
          date: this.sessionDefaultItem?.date,
          startTime: this.sessionDefaultItem?.startTime,
          endTime: this.sessionDefaultItem?.endTime,
        })
        this.sessionsOnlineStatus = status
      },
      setEventItem() {
        const statue = {
          inProgress: eventIsStart(`${ this.sessionItem.date } ${ this.sessionItem.startTime }`) && !eventIsEnd(`${ this.sessionItem.date } ${ this.sessionItem.endTime }`),
          alias: this.orderItem?.alias,
          brands: this.orderItem?.brands,
          dateType: this.orderItem?.dateType,
          regStatus: this.orderItem?.regStatus,
          registrationType: this.orderItem?.registrationType,
          seriesNum: this.orderItem?.seriesNum,
          type: this.orderItem?.type,
          dateTimeRange: this.dateTimeRange,
          contact: this.orderItem?.contact,
          requiredEvent: this.orderItem?.requiredEvent || [],
          ...this.sessionItem, ...this.sessionItem?.info
        }
        this.eventItem = statue;
      },
    }
  }
</script>
<template>
  <Layout type="brand">
    <BaseBanner
      :title="orderItem.title"
      :image="require('@assets/images/member/banner.png')"
      custom-class="isStyleWhite isArticle isDefaultBgEventItem"
      class="d-md-block d-none"
    />
    <div :class="$style.live" class="section">
      <template v-if="youtubeId">
        <div class="row no-gutters d-md-none">
          <div class="col-lg-8 live__left">
            <div class="embed-responsive embed-responsive-16by9">
              <iframe
                :src="`https://www.youtube.com/embed/${ youtubeId }`"
                class="embed-responsive-item"
                frameborder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              >
              </iframe>
            </div>

          </div>
          <div class="col-lg-4">
            <template v-if="$globalIsTouchDevice">
              <BaseButton
                class="isStyleDark isSmall isFull isOutline"
                :href="`https://www.youtube.com/watch?v=${ youtubeId }`"
                target="_blank"
              >
                查看聊天室
              </BaseButton>
            </template>
            <template v-else>
              <iframe
                id="chat-embed"
                class="live-chat"
                :src="`https://www.youtube.com/live_chat?v=${ youtubeId }&is_popout=1&embed_domain=${hostname}`"
                frameborder="0"
                referrerPolicy="origin"
              ></iframe>
            </template>

          </div>
        </div>
      </template>
      <div class="container">
        <h2 class="live__title d-md-block d-none">線上直播</h2>
        <template v-if="youtubeId">
          <div class="row no-gutters d-md-flex d-none">
            <div class="col-lg-8 live__left">
              <div class="embed-responsive embed-responsive-16by9">
                <iframe
                  :src="`https://www.youtube.com/embed/${ youtubeId }`"
                  class="embed-responsive-item"
                  frameborder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                >
                </iframe>
              </div>

            </div>
            <div class="col-lg-4">
              <template v-if="$globalIsTouchDevice">
                <BaseButton
                  class="isStyleDark isSmall isFull isOutline"
                  :href="`https://www.youtube.com/watch?v=${ youtubeId }`"
                  target="_blank"
                >
                  查看聊天室
                </BaseButton>
              </template>
              <template v-else>
                <iframe
                  id="chat-embed"
                  class="live-chat"
                  :src="`https://www.youtube.com/live_chat?v=${ youtubeId }&is_popout=1&embed_domain=${hostname}`"
                  frameborder="0"
                  referrerPolicy="origin"
                ></iframe>
              </template>

            </div>
          </div>
        </template>
        <template v-else>
          <BaseNull
            content="尚未提供 Youtube 直播連結或者已移除，若有疑問請洽詢客服"
          />
        </template>
        <div class="live__info">
          <div class="live__info__title d-flex justify-content-between">
            <div>{{ sessionItem.info.title }}</div>
            <div class="d-eflex">
              <div v-if="youtubeId"
                  :class="sessionsOnlineStatus.class2"
                  class="live__info__state ml-2"
                >
                  {{sessionsOnlineStatus.title}}
              </div>
            </div>
          
          </div>
          <span class="text-small d-md-inline d-none">
            <i class="fal fa-clock"></i>
            發布時間： {{ publishDate }}
          </span>
        </div>
        <div class="row">
          <div class="col-lg-7 order-lg-first order-last">
            <template v-if="!!sessionItem.info.description">
              <h3 class="d-md-block d-none">活動簡介</h3>
              <el-divider content-position="left" class="d-md-none isStyleDialog">活動簡介</el-divider>
              <div class="mt-4 article" v-html="sessionItem.info.description"></div>
            </template>
            <template v-if="!!sessionItem.info.personnels[0]">
              <div :class="$style.detail">
                <h3 class="d-md-block d-none">講師介紹</h3>
                <el-divider content-position="left" class="d-md-none isStyleDialog mt-5">講師介紹</el-divider>
                <ListPersonnels
                  class="mt-4"
                  :personnel-list="sessionItem.info.personnels"
                />
              </div>
            </template>
            <template v-if="!!sessionItem.info.files[0]">
              <h3 class="d-md-block d-none">活動檔案下載</h3>
              <el-divider content-position="left" class="d-md-none isStyleDialog mt-5">活動檔案下載</el-divider>
              <div v-for="(fileItem, index) in sessionItem.info.files" :key="index" class="mt-4">
                <File
                  type="download"
                  :item="fileItem"
                  icon="<i class='icomoon icon-download'></i>"
                />
              </div>
            </template>
          </div>
          <div class="col-lg-5">
            <ArticleSide
              type="live"
              :event-item="eventItem"
            />
          </div>
        </div>
        <BasePre>sessionItem: {{ sessionItem }}</BasePre>
        <BasePre>orderItem: {{ orderItem }}</BasePre>
      </div>
    </div>
  </Layout>
</template>
<style lang="scss" module>
  .live {
    // padding-top: 8rem;
      @include max-md {
        padding-top: 0;
        padding-bottom: 2rem;
      }
    :global {
      .embed-responsive {
        // margin-bottom: 5rem;

      }

      .live-chat {
        width: 100%;
        height: 100%;
        border: $color-gray-3 1px solid;

        @include max-lg {
          min-height: 450px;
        }
      }

      .live {
        &__left {
          position: relative;
          background: #F9F9F9;
        }

        &__info {
          width: 100%;
          margin: 1.5rem 0 3rem;
          &__title {
            display: flex;
            justify-content: flex-start;
            margin-bottom: 0.5rem;
            font-size: 1.5rem;
            font-weight: 500;
            @include max-md {
              font-size: 1.375rem;
            }
          }

          &__state {
            // position: absolute;
            // right: 10px;
            // bottom: 10px;
            z-index: 3;
            display: inline-block;
            padding: .4rem 1rem;
            font-size: 1rem;
            color: #FFF;
            text-align: center;
            border-radius: 20px;
            margin-bottom: 0.5rem;
            background: $color-gray-6;
            flex-shrink: 0;
            max-height: 37px;
            @include max-md {
              font-size: 0.875rem;
              flex-shrink: 0;
              height: 35px;
              order: 1;
            }
            &.isStyleDanger {
              background: #CD0202;
            }
            &.isStyleDark {
              background: $color-gray-6;
            }
            &.isStylePrimary {
              background: $color-primary;
            }
          }
        }

        &__title {
          margin-bottom: 3.125rem;
          font-size: 1.875rem;
        }
      }
    }
  }

  .detail {
    p {
      margin-bottom: 2.5rem;
    }

    h3 {
      padding-top: 3rem;
      margin-bottom: 3rem;
      font-size: 1.875rem;
    }
    :global {
      .detail {
        // &__title {
        //   margin-bottom: 1.4rem;
        //   font-size: 1.25em;
        // }
        // &__content {
        //   margin-bottom: 3.75rem;
        //   color: $color-gray-6;
        // }
        &__content {
          a {
            color: $color-gray-7;

            &:hover {
              color: $color-primary;
              text-decoration: none;
            }
          }
        }
      }

      .el-timeline {
        margin-bottom: 2rem;
      }
    }
  }

  .liveBtn {
    position: fixed;
    bottom: 176px;
    right: 10px;
    width: 60px;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
    white-space: unset;
    font-size: 0.875rem;
    letter-spacing: 0.1em;
    z-index: 3;
    &.active {
      bottom: 301px;
    }
  }

</style>
